import Box from '@mui/material/Box';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useDispatch } from 'react-redux';
import { useWebSocket } from '../../../helpers/websocket';
import { setSocketId } from 'features/auth';
import { MenuButton } from 'assets/style-components/button';
import { useCallback, useMemo, useEffect, useState } from 'react';
import ganttStore from 'components/projectOverview/gantt/ganttConfig/ganttStore';
import { closeSnackbar, useSnackbar } from 'notistack';
import { Button, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

/**
 * Gantt Socket Component
 * @param {String} ganttId
 * @param {[String]} channelNames
 * @param {Object} reloadTrigger
 * @returns
 */
const GanttSocketComponent = ({ ganttId, channelNames, reloadTrigger }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  // const gantt = ganttStore.getGantt(ganttId);

  const [isOutdated, setIsOutdated] = useState(false);
  const { echo } = useWebSocket();

  const handleReload = useCallback(() => {
    reloadTrigger();
    setIsOutdated(false);
    closeSnackbar('Gantt Out Of Date');
  }, []);

  const handleUpdateStatus = useCallback(() => {
    console.log('Socket Received =>');
    setIsOutdated(true);
    enqueueSnackbar('Gantt is out of date please reload', {
      key: 'Gantt Out Of Date',
      // variant: 'info',
      action: (id) => (
        <>
          <Button color={'secondary'} variant={'text'} onClick={handleReload}>
            Reload
          </Button>
          <IconButton color={'error'} onClick={() => closeSnackbar(id)}>
            <Close />
          </IconButton>
        </>
      ),
      preventDuplicate: true,
      persist: true,
    });
  }, [enqueueSnackbar, handleReload]);

  const eventListeners = useMemo(
    () => ({
      TaskUpdated: handleUpdateStatus,
      TaskCreated: handleUpdateStatus,
      TaskDeleted: handleUpdateStatus,
      DependencyUpdated: handleUpdateStatus,
      DependencyCreated: handleUpdateStatus,
      DependencyDeleted: handleUpdateStatus,
    }),
    [handleUpdateStatus]
  );

  useEffect(() => {
    const connectedChannels = [];

    channelNames?.forEach((channelName, index) => {
      const connectedChannel = echo.join(channelName).here((users) => {
        if (index === 0) {
          dispatch(setSocketId(echo.socketId()));
        }
      });

      for (const [event, listener] of Object.entries(eventListeners)) {
        const eventListener = (data) => {
          listener(data);
        };
        connectedChannel.listen(event, eventListener);
        connectedChannels.push(channelName);
      }
    });

    return () => {
      connectedChannels.forEach((channelName) => {
        echo.leave(channelName);
      });
      dispatch(setSocketId(null));
      closeSnackbar('Gantt Out Of Date');
    };
  }, [echo, channelNames, eventListeners, dispatch]);

  return (
    <Box justifyContent={'flex-end'} mx={1}>
      <MenuButton
        disabled={!isOutdated}
        endIcon={<RefreshIcon fontSize="small" />}
        isHighlighted={isOutdated}
        onClick={handleReload}
      >
        {isOutdated ? 'Outdated' : 'Updated'}
      </MenuButton>
    </Box>
  );
};

export default GanttSocketComponent;
